import React from 'react';
import { LuGitBranch, LuPlus } from "react-icons/lu";
import WorkflowCard from './WorkflowCard';

const WorkflowGrid = ({ 
  workflows = [], 
  isLoading = false, 
  onWorkflowClick, 
  onNewWorkflowClick,
  emptyStateTitle = "No Workflows",
  emptyStateDescription = "Create your first workflow to get started"
}) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        {[1, 2, 3, 4, 5, 6].map(placeholder => (
          <div className="w-full h-48 relative" key={placeholder}>
            <div className="p-4 w-full h-full bg-[#1e1e1e] border border-[#ffffff10] rounded-xl flex flex-col justify-between animate-pulse">
              <div className="flex space-x-2 items-center">
                <div className="p-3 bg-[#ffffff20] rounded-lg">
                  <div className="w-6 h-6 bg-[#ffffff30] rounded"></div>
                </div>
                <div className="flex-1">
                  <div className="h-5 bg-[#ffffff20] rounded mb-2"></div>
                  <div className="h-4 bg-[#ffffff10] rounded w-3/4"></div>
                </div>
              </div>
              <div className="flex space-x-2 items-center">
                <div className="p-3">
                  <div className="w-5 h-5 bg-[#ffffff20] rounded-full"></div>
                </div>
                <div className="flex-1">
                  <div className="h-4 bg-[#ffffff10] rounded w-1/2"></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (workflows.length === 0) {
    return (
      <div className="flex flex-col items-center w-full justify-center my-4 bg-[#ffffff10] border border-[#ffffff15] rounded-xl">
        <LuGitBranch className="w-16 h-16 text-[#ffffff30] mb-4" />
        <div className="text-2xl mb-2">{emptyStateTitle}</div>
        <div className="text-[#ffffff50] mb-6">{emptyStateDescription}</div>
        <div
          onClick={onNewWorkflowClick}
          className="px-4 py-2 font-medium border border-[#ffffff15] space-x-2 rounded-lg flex items-center justify-center hover:bg-[#ffffff20] transition cursor-pointer active:scale-95 transform duration-150 ease-out"
        >
          <LuPlus />
          <div>Create Workflow</div>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
      {workflows.map(workflow => (
        <WorkflowCard
          key={workflow.id}
          name={workflow.name || workflow.title}
          createdAt={workflow.createdAt}
          onClick={() => onWorkflowClick(workflow)}
        />
      ))}
    </div>
  );
};

export default WorkflowGrid;